// Generated by purs version 0.13.8
"use strict";
var Data_Unit = require("../Data.Unit/index.js");
var $$undefined = Data_Unit.unit;
module.exports = {
    "undefined": $$undefined
};
